export const SAVE_NAME = 'SAVE_NAME';
export const SET_AUTH = 'SET_AUTH';
export const RESET_STORE='RESET_STORE'
export const SET_LOGGEDIN_PANEL='SET_LOGGEDIN_PANEL'